import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import './index.css';

const PaginationNextPrev = props => {
  if (!props.paginationData) {
    return null;
  }

  return (
    <div className="pagination-next-prev">
      <div className="pagination-next-prev_pref">
        {props.paginationData.currentPage > 1 ? (
          <button
            className="btn btn-default btn-block btn-muted"
            onClick={() =>
              props.handlePageClick(props.paginationData.currentPage - 1)
            }
          >
            <i className="fa fa-angle-left" /> {t('Предыдущая')}
          </button>
        ) : null}
      </div>
      <div className="pagination-next-prev_next">
        {props.currentPageCount === props.paginationData.perPage ? (
          <button
            className="btn btn-default btn-block btn-muted"
            onClick={() =>
              props.handlePageClick(props.paginationData.currentPage + 1)
            }
          >
            {t('Следующая')} <i className="fa fa-angle-right" />
          </button>
        ) : null}
      </div>
    </div>
  );
};

PaginationNextPrev.defaultProps = {
  paginationData: null
};

PaginationNextPrev.propTypes = {
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }),
  handlePageClick: PropTypes.func.isRequired,
  currentPageCount: PropTypes.number.isRequired
};

export default PaginationNextPrev;



// WEBPACK FOOTER //
// ./src/components/Common/PaginationNextPrev/index.js